import { createFileRoute } from '@tanstack/react-router';
import { EcranImport } from '../admin/import/EcranImport';

export const Route = createFileRoute('/admin/import')({
  component: EcranImport,
});
